var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "autocomplete" },
    [
      _c("autocomplete", {
        attrs: {
          search: _vm.search,
          placeholder: "Search",
          "aria-label": "Search for a country",
          debounceTime: 50
        },
        on: { submit: _vm.handleSubmit },
        scopedSlots: _vm._u([
          {
            key: "result",
            fn: function(ref) {
              var result = ref.result
              var props = ref.props
              return [
                _c(
                  "li",
                  _vm._b(
                    { staticClass: "autocomplete-result wiki-result" },
                    "li",
                    props,
                    false
                  ),
                  [
                    _c("div", { staticClass: "wiki-title" }, [
                      _vm._v(
                        "\n          " + _vm._s(result.title) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "wiki-snippet",
                      domProps: { innerHTML: _vm._s(result.snippet) }
                    })
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }